var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / heroicons / Outline / clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12 8.86133V12.8613L15 15.8613M21 12.8613C21 17.8319 16.9706 21.8613 12 21.8613C7.02944 21.8613 3 17.8319 3 12.8613C3 7.89077 7.02944 3.86133 12 3.86133C16.9706 3.86133 21 7.89077 21 12.8613Z",
    stroke: "#21272A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.0dc2bb11f73fe136dcb1dc9a6e24840c.svg";
export { ForwardRef as ReactComponent };